module.exports = __webpack_public_path__ + "img/russian_spring_punch_1.c227edc7.jpg";